import { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import useAuth from './useAuth';
import useRefreshToken from './useRefreshToken';
import { parseUserInfo } from '../../utils';

// Persists the user info by decoding the JWT token info on page load and updating the store
const useAuthPersist = () => {
  const [isLoading, setLoading] = useState(true);
  const { auth, login } = useAuth();
  const refresh = useRefreshToken();
  const dispatch = useDispatch();

  useEffect(() => {
    let isMounted = true; // Prevent state updates if the component unmounts

    const verifyRefreshToken = async () => {
      try {
        if (isMounted) {
          await refresh();
        }
      } catch (error) {
        console.error('Error verifying refresh token:', error);
      } finally {
        if (isMounted) {
          setLoading(false);
        }
      }
    };

    if (!auth?.user) {
      verifyRefreshToken();
    } else {
      setLoading(false);
    }

    return () => {
      isMounted = false; // Cleanup to prevent memory leaks
    };
  }, [auth?.user, refresh]);

  useEffect(() => {
    const token = auth?.user?.token;
    if (token) {
      const user = parseUserInfo(token);
      dispatch(login(user));
    }
  }, [isLoading, dispatch, login, auth?.user?.token]);

  return isLoading;
};

export default useAuthPersist;
